export enum TicketCategory {
  SUPPORT = 'SUPPORT',
  ALARM_FEEDBACK = 'ALARM_FEEDBACK',
  DELETE_ACCOUNT_FEEDBACK = 'DELETE_ACCOUNT_FEEDBACK',
  APP_RATING_FEEDBACK = 'APP_RATING_FEEDBACK',
  RELIGIOUS_INQUIRY = 'RELIGIOUS_INQUIRY',
}
